import React, { useCallback, useMemo } from 'react';
import { Button, Card } from 'tea-component';
import { TTestMode } from '../../types';
import './index.scss';

interface IInputAreaProps {
  value: string;
  mode: TTestMode;
  onChange: (value: string) => void;
  onRender: () => void;
  onClear: () => void;
  isValidating: boolean;
}

const MODE_PLACEHOLDER: Record<TTestMode, string> = {
  biData: `请输入 biData 格式的 JSON 数据，例如：
{
  "data": {
    "metrics_info": [...],
    "dimension_info": [...],
    "data": [...],
    "xAxis": [...]
  }
}`,
  echartsOption: `请输入原生 ECharts options，例如：
{
  "xAxis": { "type": "category", "data": ["A","B","C"] },
  "yAxis": { "type": "value" },
  "series": [{ "type": "bar", "data": [10, 20, 30] }]
}`,
};

const InputArea = React.memo(({
  value,
  mode,
  onChange,
  onRender,
  onClear,
  isValidating,
}: IInputAreaProps) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      onChange(e.target.value);
    },
    [onChange],
  );

  const placeholder = useMemo(() => MODE_PLACEHOLDER[mode], [mode]);

  return (
    <Card className="dba-input-area-container">
      <Card.Header>
        <h3>JSON 数据输入</h3>
      </Card.Header>
      <Card.Body>
        <textarea
          className="dba-json-input"
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={isValidating}
        />
        <div className="dba-button-group">
          <Button type="primary" onClick={onRender} disabled={isValidating || !value.trim()}>
            {isValidating ? '检测中...' : '渲染图表'}
          </Button>
          <Button onClick={onClear} disabled={isValidating}>
            清空
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
});

InputArea.displayName = 'InputArea';

export default InputArea;
